import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
// var $ = require("jquery");

import VueI18n from "vue-i18n";

// Importing JSON files
import enLocale from "./locales/en.json";
import frLocale from "./locales/fr.json";
import arLocale from "./locales/ar.json";


Vue.use(VueI18n);

import "./app.css";
import "./axios-interceptor"; // Import the interceptor file

import DashboardAdmin from "./layouts/DashboardAdmin.vue";
import Default from "./layouts/Default.vue";
import Login from "./layouts/Login.vue";
import DataTable from "./components/cards/DataTable.vue";
import VueSelect from "./components/cards/VueSelect.vue";
import VueConfirmDialog from "./components/cards/VueConfirmDialog.vue";

import VueActionButtons from "./components/cards/VueActionButtons.vue";

import OrderDetailsCard from "./components/cards/OrderDetailsCard.vue";
import DeliveryDetailsCard from "./components/cards/DeliveryDetailsCard.vue";
import CheckDetailsCard from "./components/cards/CheckDetailsCard.vue";


import PieChart from "./components/chart/PieChart.vue";

import confirm from "./plugins/confirm";
import loading from "./plugins/loading";
import toast from "./plugins/toast";
import axiosPlugin from "./plugins/axios";
import ModalPlugin from './plugins/modal';
import download from "./plugins/download";
import constant from "./constant";

Vue.use(confirm);
Vue.use(loading);
Vue.use(toast);
Vue.use(axiosPlugin);
Vue.use(ModalPlugin); 
Vue.use(download); 


Vue.mixin({
  beforeCreate() {
    if (this.$options.store) {
      this.$options.store.$api = this.$api;
    }
  },
});

Vue.prototype.$userRole = store.getters.userRole;
Vue.prototype.$settings = store.getters.getSettings;  // Add settings to Vue prototype

// Make settings globally accessible via Vue prototype
const settings = store.getters["auth/allSettings"];

// Loop through all settings and dynamically add them to Vue.prototype
Object.keys(settings).forEach((key) => {
  Vue.prototype[`$${key}`] = settings[key];
});


Object.defineProperty(Vue.prototype, "$setting", {
  get() {
    return (key) => store.getters["auth/getSetting"](key);
  },
});


// import { toFixedWithSpace } from "./filters";
// Vue.prototype.$toFixedWithSpace = toFixedWithSpace;
// Vue.filter("toFixedWithSpace", toFixedWithSpace);

Vue.config.productionTip = false;

Vue.component("layout-dashboard", DashboardAdmin);
Vue.component("layout-default", Default);
Vue.component("layout-login", Login);
Vue.component("vue-data-table", DataTable);
Vue.component("vue-select", VueSelect);
Vue.component("vue-confirm-dialog", VueConfirmDialog);
Vue.component("vue-action-buttons", VueActionButtons);

Vue.component("vue-order-details", OrderDetailsCard);
Vue.component("vue-delivery-details", DeliveryDetailsCard);
Vue.component("vue-check-details", CheckDetailsCard);

Vue.component("vue-pie-chart", PieChart);

Vue.component("vueInternetChecker", require("vue-internet-checker"));

window.axios = require("axios");
// axios.defaults.baseURL = "http://localhost:8081";
// axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const token = localStorage.getItem(constant.authToken);
axios.defaults.headers.common["Authorization"] =
  "Bearer " + String(token).replaceAll('"', "");

window.addEventListener("storage", (event) => {
  if (event.key === constant.userRoleKey) {
    store.commit("SET_USER_ROLE", event.newValue);
  }
});


const messages = {
  en: enLocale,
  fr: frLocale,
  ar: arLocale,
};

const i18n = new VueI18n({
  locale: "fr", // Set the default locale
  fallbackLocale: "fr", // Set the fallback locale in case the current locale is not found
  messages,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
